export default __webpack_public_path__ + "static/media/LossSKU.0f4d7f04.svg";